import React from 'react';
import { useNavigate } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    console.error("Error caught in Error Boundary:", error, errorInfo);
    alert("There was an error. Please try again later. You will be redirected to the maintenance page.");

    // Immediately redirect to the maintenance page
    window.location.href = '/maintenance';
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if the error state was just set
    if (this.state.hasError && !prevState.hasError) {
      // Delay the redirection slightly to ensure the error state is applied
      setTimeout(() => {
        window.location.href = '/maintenance';
      }, 0);
    }
  }

  render() {
    if (this.state.hasError) {
      // Return null to prevent rendering the rest of the UI
      return null;
    }

    return this.props.children;
  }
}

function ErrorBoundaryWrapper(props) {
  return <ErrorBoundary {...props} />;
}

export default ErrorBoundaryWrapper;
